export const feedBackStatus: Record<"NO_FEEDBACK" | "HAS_FEEDBACK", number> = {
  // 0未評論 １已評論
  NO_FEEDBACK: 0,
  HAS_FEEDBACK: 1,
};
